import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bill-no-modal',
  templateUrl: './bill-no-modal.component.html',
  styleUrls: ['./bill-no-modal.component.scss']
})
export class BillNoModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
